import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import apiCall from "../../../components/Api";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import BackBtn from "../../../components/Common/backBtn";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import SucessModal from "../../../components/Modal/SucessModal";
import { ManufacturerBreadcrumbsList } from "../Const";

const ManufacturerListForm = ({ edit = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}manufacturer/get/${id}`)
      .then((response) => {
        setValue("manufacturer_name", response.data.manufacturer_name);
        setValue("manufacturer_address", response.data.manufacturer_address);
        setValue("country_of_origin", response.data.country_of_origin);
        setValue("customer_email", response.data.customer_email);
        setValue("active", response.data.active);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const onSubmit = async (fields) => {
    if (edit) {
      const result = await apiCall(
        `manufacturer/update/${id}`,
        "PATCH",
        fields,
      );
      if (result.data?._id) {
        setSuccess(true);
      }
    } else {
      const result = await apiCall(`manufacturer/create`, "POST", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    }
  };

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="healthsyMasterBreadCrumbs"
                breadcrumbsList={ManufacturerBreadcrumbsList("", edit)}
              />
              <BackBtn navigatePath="/healthsy-services/order-medicines/masters/manufacturer" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Manufacturer Name"
                  errorText="Please enter the Manufacturer Name"
                  name="manufacturer_name"
                  placeholder="Type here..."
                />
              </div>

              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Manufacturer Address"
                  errorText="Please enter the Manufacturer Address"
                  name="manufacturer_address"
                  placeholder="Type here..."
                />
              </div>
            </div>
            <div className="row car-dep-form">
              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Customer Email"
                  errorText="Please enter the Customer Email"
                  name="customer_email"
                  placeholder="Type here..."
                />
              </div>

              <div className="col-5">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Country of Origin"
                  errorText="Please enter the Country of Origin"
                  name="country_of_origin"
                  placeholder="Type here..."
                />
              </div>
            </div>
            <div className="row car-dep-form pt-3">
              <div className="col-3">
                <InputRadioField
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  className="manufacturerRadioBtn"
                />
              </div>
            </div>
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </MainconternLayout>

      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/healthsy-services/order-medicines/masters/manufacturer"}
          name="new manufacturer list"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default ManufacturerListForm;
